// create a container and set the full-size image as its background
function createOverlay(image) {
  const overlayImage = document.createElement('img');
  overlayImage.setAttribute('src', `${image.src}`);
  overlay = document.createElement('div');
  prepareOverlay(overlay, overlayImage);

  image.style.opacity = '50%';
  toggleLoadingSpinner(image);

  overlayImage.onload = () => {
    toggleLoadingSpinner(image);
    image.parentElement.insertBefore(overlay, image);
    image.style.opacity = '100%';
  };

  return overlay;
}

function prepareOverlay(container, image) {
  container.setAttribute('class', 'image-magnify-full-size');
  container.setAttribute('aria-hidden', 'true');
  container.style.backgroundImage = `url('${image.src}')`;
  container.style.backgroundColor = 'var(--gradient-background)';
}

function toggleLoadingSpinner(image) {
  const loadingSpinner = image.parentElement.parentElement.querySelector(`.loading__spinner`);
  loadingSpinner.classList.toggle('hidden');
}

function moveWithHover(image, event, zoomRatio) {
  // calculate mouse position
  const ratio = image.height / image.width;
  const container = event.target.getBoundingClientRect();
  const xPosition = event.clientX - container.left;
  const yPosition = event.clientY - container.top;
  const xPercent = `${xPosition / (image.clientWidth / 100)}%`;
  const yPercent = `${yPosition / ((image.clientWidth * ratio) / 100)}%`;

  // determine what to show in the frame
  overlay.style.backgroundPosition = `${xPercent} ${yPercent}`;
  overlay.style.backgroundSize = `${image.width * zoomRatio}px`;
}

function magnify(image, zoomRatio) {
  const overlay = createOverlay(image);
  overlay.onclick = () => overlay.remove();
  overlay.onmousemove = (event) => moveWithHover(image, event, zoomRatio);
  overlay.onmouseleave = () => overlay.remove();
}

class Zoomable {
  constructor(element, config) {
      this.element = element;
      this.config = this._mergeConfig(config);

      const { initialZoom, minZoom, maxZoom } = this.config;

      this.zoomed = false;
      this.initialZoom = Math.max(Math.min(initialZoom, maxZoom), minZoom);
      this.zoom = this.initialZoom;

      this.img = element.querySelector("img");
      if(!this.img) return;
      this.img.draggable = false;
      this.element.style.setProperty("--zoom", this.initialZoom);

      this._addEventListeners();
  }

  static get Default() {
    return {
      initialZoom: 2,
      minZoom: 1.25,
      maxZoom: 4,
      zoomSpeed: 0.01
    };
  }

  _addEventListeners() {
      this.element.addEventListener("mouseover", () =>
          this._handleMouseover()
      );
      this.element.addEventListener("mousemove", (evt) =>
          this._handleMousemove(evt)
      );
      this.element.addEventListener("mouseout", () => this._handleMouseout());
      this.element.addEventListener("wheel", (evt) => this._handleWheel(evt));

      this.element.addEventListener("touchstart", (evt) =>
          this._handleTouchstart(evt)
      );
      this.element.addEventListener("touchmove", (evt) =>
          this._handleTouchmove(evt)
      );
      this.element.addEventListener("touchend", () => this._handleTouchend());
  }

  _handleMouseover() {
      if (this.zoomed) {
          return;
      }

      this.element.classList.add("zoomable--zoomed");

      this.zoomed = true;
  }

  _handleMousemove(evt) {
      if (!this.zoomed) {
          return;
      }

      const elPos = this.element.getBoundingClientRect();

      const percentageX = `${
          ((evt.clientX - elPos.left) * 100) / elPos.width
      }%`;
      const percentageY = `${
          ((evt.clientY - elPos.top) * 100) / elPos.height
      }%`;

      this.element.style.setProperty("--zoom-pos-x", percentageX);
      this.element.style.setProperty("--zoom-pos-y", percentageY);
  }

  _handleMouseout() {
      if (!this.zoomed) {
          return;
      }

      this.element.style.setProperty("--zoom", this.initialZoom);
      this.element.classList.remove("zoomable--zoomed");

      this.zoomed = false;
  }

  _handleWheel(evt) {
      if (!this.zoomed) {
          return;
      }

      evt.preventDefault();

      const newZoom = this.zoom + evt.deltaY * (this.config.zoomSpeed * -1);
      const { minZoom, maxZoom } = this.config;

      this.zoom = Math.max(Math.min(newZoom, maxZoom), minZoom);
      this.element.style.setProperty("--zoom", this.zoom);
  }

  _handleTouchstart(evt) {
      evt.preventDefault();

      this._handleMouseover();
  }

  _handleTouchmove(evt) {
      if (!this.zoomed) {
          return;
      }

      const elPos = this.element.getBoundingClientRect();

      let percentageX =
          ((evt.touches[0].clientX - elPos.left) * 100) / elPos.width;
      let percentageY =
          ((evt.touches[0].clientY - elPos.top) * 100) / elPos.height;

      percentageX = Math.max(Math.min(percentageX, 100), 0);
      percentageY = Math.max(Math.min(percentageY, 100), 0);

      this.element.style.setProperty("--zoom-pos-x", `${percentageX}%`);
      this.element.style.setProperty("--zoom-pos-y", `${percentageY}%`);
  }

  _handleTouchend(evt) {
      this._handleMouseout();
  }

  _mergeConfig(config) {
      return {
          ...this.constructor.Default,
          ...(typeof config === "object" ? config : {})
      };
  }
}

function enableZoomOnHover(zoomRatio) {
  const images = document.querySelectorAll('.image-magnify-hover');
  images.forEach((image) => {
    new Zoomable(image);
  });
}

enableZoomOnHover();